
import { doorQuery } from "@/apis/accessControl";
import { reactive, ref, toRefs, defineComponent, onMounted, watch, onBeforeUnmount, } from "vue";
import { bindingAccess, unbindingAccess } from '@/apis/building'
import { ElMessage } from "element-plus";
import dialogs from '@/components/dialogs/dialogs.vue'
import paging from '@/components/paging/paging.vue'

export default defineComponent({
    components: {
        dialogs,
        paging
    },
    props: {
        floorData: {
            type: Object,
            default: ''
        }
    },
    setup(props) {
        const state = reactive({
            total: 0,
            unbindDialogs: false,
            centerDialogVisible: false,
            updateActiveFlag: false,
            value: '',
            numbers: '',
            unbindData: '',
            dialogAccessControl: false,
            relationAccessList: [] as any,
            form: {
                region: '',
            },
            rules: {
                selectRules: [{ required: true, message: 'Please select Activity zone', trigger: 'blur', }]
            },
            accessControlList: [

            ] as any,
            options: [

            ],
            params: {
                floor_id: props.floorData.ID,
                pageSize: 12,
                page: 1,
                limit: true
            },
            // 页码切换
            changePage(val: number) {
                state.params.page = val
                state.relationAccessQuery()
            },
            checkChange(val: any) {
                console.log('111', val)
                state.unbindData = ''
                state.relationAccessList.forEach((item: any) => {
                    if (item.checkedFlag) {
                        state.unbindData += item.id + ','
                    }
                })
                if (state.unbindData) {
                    state.updateActiveFlag = true
                } else {
                    state.updateActiveFlag = false
                }
            },
            selcetChange(val: any) {
                console.log('选中的指', val)
                state.numbers = ''
                if (val.label > 1) {
                    val.forEach((item: any) => {
                        state.numbers += item + ','
                    })
                } else {
                    state.numbers = val
                }

            },
            handleClose() {
                state.dialogAccessControl = false
            },
            confirm() {

                bindingAccess(state.numbers, props.floorData.ID).then((res: any) => {
                    console.log('关联门禁结果', res)
                    if (res.code == 200) {
                        state.relationAccessQuery()
                        state.dialogAccessControl = false
                        ElMessage({
                            message: "关联门禁成功",
                            type: "success",
                        })
                    } else {
                        ElMessage.error(`${res.msg}`)
                    }
                })
            },
            cancelRelation() {
                if (state.unbindData) {
                    state.unbindDialogs = true
                } else {
                    return
                }
            },
            OFF() {
                state.unbindDialogs = false
            },
            ON() {
                unbindingAccess(state.unbindData).then((res: any) => {
                    console.log('解绑结果', res)
                    if (res.code == 200) {
                        state.relationAccessQuery()
                        state.unbindDialogs = false
                        ElMessage({
                            message: "门禁解绑成功",
                            type: "success",
                        })
                    } else {
                        ElMessage.error(`解绑失败：${res.msg}`)
                    }
                })
            },
            // 查询全部门禁
            accessControlQuery() {
                let params = {
                    floor_id: '-1',
                    pageSize: 12,
                    page: 1,
                    limit: true
                }
                doorQuery(params).then((res: any) => {
                    console.log('全部门禁查询', res)
                    res.data.list.forEach((item: any) => {
                        if (item.floor_id != '' || item.floor_id) {
                            item.disabled = true
                        } else {
                            item.disabled = false
                        }
                    })
                    state.accessControlList = res.data.list
                })
            },
            // 查询关联的门禁
            relationAccessQuery() {

                doorQuery(state.params).then((res: any) => {
                    console.log('关联门禁查询', res)
                    state.total = res.data.total
                    if (res.data.list.length > 0) {
                        res.data.list.forEach((item: any) => {
                            item.checkedFlag = false
                        });
                    }
                    state.relationAccessList = res.data.list
                })
            },
            init() {
                state.relationAccessQuery()
                state.accessControlQuery()
            }
        })

        watch(() => props.floorData, (newVal, oldVal) => {
            console.log('新数据', newVal)
            console.log('旧数据', oldVal)
            if (newVal.floorFlag) {
                state.init()
            } else {
                return
            }
        })

        onMounted(() => {
            console.log('父组件数据', props)
            state.init()
        })

        return {
            ...toRefs(state)
        }
    }
})
